import React from 'react';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import 'assets/vendors/style';
import 'styles/wieldy.less';
import configureStore, { history } from './store';

import App from 'layout/App/index';

export const store = configureStore();

const MooTeam = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default hot(module)(MooTeam);
